export const setList = (state, payload) => state.list = payload;
export const setLsTags = (state, payload) => state.lsTags = payload;
export const setListForLs = (state, payload) => state.listForLs = payload;
export const deleteTag = (state, id) => state.list = state.list.filter(tag => tag.id !== id)